import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ParentsConsentContent from "../../components/ParentsConsent/ParentsConsentContent";

const ParentsConsent = () => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle
            pageTitle={"Parental / Guardian Consent Form"}
            pagesub={"Home"}
          />
          <ParentsConsentContent />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default ParentsConsent;
